export default "__VITE_ASSET__ihbwTFYI__";